@let _v = value() | percent: '1.0-0';
@if (value() <= 0.01 && emptyText()) {
  <div class="progress-bar" [style.--value]="`'${emptyText()}'`">
    <mat-progress-bar mode="determinate" [value]="0"></mat-progress-bar>
  </div>
} @else {
  <div
    class="progress-bar"
    [style.--value]="`'${_v}'`"
    [style.--percent]="`${clippedValue() * 100}%`"
    [ngClass]="{ overfilled: value() > 1, filled: value() >= 0.9 }"
  >
    <mat-progress-bar mode="determinate" [value]="value() * 100"></mat-progress-bar>
  </div>
}
